import * as React from "react";
import { DataGrid } from "@mui/x-data-grid";
import {
  Box,
  Paper,
  Typography,
  Button,
  Modal,
  Select,
  MenuItem,
} from "@mui/material";
import axios from "axios";
import { localeTextVietnamese } from "../../utils/localeText-vn";
import {
  formatCurrencyVND,
  getPaymentMethod,
  formatDate,
} from "../../utils/CurrencyFormat";
import { toast } from "react-toastify";
import swal from "sweetalert";

export default function OrderPage() {
  const [rows, setRows] = React.useState([]);
  const [open, setOpen] = React.useState(false);
  const [orderData, setOrderData] = React.useState({});
  const [orderDetail, setOrderDetail] = React.useState([]);
  const [selectedValue, setSelectedValue] = React.useState("");
  const [totalItems, setTotalItems] = React.useState(0);
  const [paginationModel, setPaginationModel] = React.useState({
    page: 0,
    pageSize: 10,
  });

  const handleChange = (event) => {
    setSelectedValue(event.target.value);
  };

  const status = [
    {
      name: "Chờ xác nhận",
      value: 0,
    },
    {
      name: "Đang giao",
      value: 1,
    },
    {
      name: "Đã giao",
      value: 2,
    },
    {
      name: "Đã huỷ",
      value: 3,
    },
  ];

  const statusMap = status.reduce((acc, item) => {
    acc[item.value] = item.name;
    return acc;
  }, {});

  // setting collumn
  const columns = [
    { field: "index", headerName: "STT", width: 100 },
    {
      field: "fullName",
      headerName: "Người đặt",
      flex: 3,
    },
    { field: "phone", headerName: "Số điện thoại người đặt", flex: 3 },
    { field: "fullNameReceive", headerName: "Người nhận", flex: 3 },
    {
      field: "orderTime",
      headerName: "Ngày giao",
      flex: 3,
      renderCell: (params) => {
        return <span>{formatDate(params.value)}</span>;
      },
    },
    {
      field: "status",
      headerName: "Trạng thái",
      flex: 3,
      renderCell: (params) => {
        const statusName = statusMap[params.value];
        return (
          <span
            style={{
              color: `${
                params.value == 0
                  ? "#ccc"
                  : params.value == 1
                  ? "#0184b7"
                  : params.value == 2
                  ? "green"
                  : "red"
              }`,
              fontWeight: "bold",
            }}
          >
            {statusName || ""}
          </span>
        );
      },
    },
    {
      field: "payment",
      headerName: "Thanh toán",
      flex: 2,
      renderCell: (params) => {
        return (
          <span>
            {params.value == 1
              ? "Ngân hàng"
              : params.value == 2
              ? "Momo"
              : "COD"}
          </span>
        );
      },
    },
    {
      field: "action",
      headerName: "Thao tác",
      description: "",
      sortable: false,
      flex: 3,
      renderCell: (params) => (
        <Box
          sx={{ display: "flex", gap: 1, alignItems: "center", height: "100%" }}
        >
          <Button
            variant="contained"
            color="success"
            onClick={(event) => {
              event.stopPropagation();
              handleOpen(params.id);
            }}
          >
            Xem chi tiết
          </Button>
          <Button
            variant="contained"
            color="error"
            onClick={(event) => {
              event.stopPropagation();
              handleDelete(params.id);
            }}
          >
            Xoá
          </Button>
        </Box>
      ),
    },
  ];

  React.useEffect(() => {
    getData();
  }, [paginationModel]);

  const getData = () => {
    axios
      .get(`/api/v1/orders`, {
        params: {
          page: paginationModel.page,
          limit: paginationModel.pageSize,
          paginationAdmin: true,
        },
      })
      .then((res) => {
        setRows(res.data.orders);
        setTotalItems(res.data.totalItems);
      })
      .catch((err) => console.log(err));
  };

  const rowsWithIndex = rows.map((row, index) => ({
    index: index + 1,
    ...row,
  }));

  const handleOpen = (id) => {
    setOpen(true);
    if (id) {
      getOrderById(id);
      getDetailData(id);
    }
  };

  const handleClose = (isReload) => {
    setOpen(!open);
    setOrderData({});
    setOrderDetail([]);
    setSelectedValue(``);
    if (isReload) {
      getData();
    }
  };

  const handleDelete = (id) => {
    swal({
      title: `Bạn muốn xóa đơn hàng này`,
      text: ` Lưu ý: Hành động không thể khôi phục lại`,
      icon: "warning",
      buttons: ["Đóng", "Xóa"],
      successMode: true,
    }).then((ok) => {
      if (ok) {
        axios
          .delete(`/api/v1/orders/${id}`)
          .then((res) => {
            toast("Xoá đơn hàng thành công", {
              type: "success",
              autoClose: 1000,
            });
            getData();
          })
          .catch((err) => {
            console.log(err);
          });
      }
    });
  };

  const getOrderById = (id) => {
    axios
      .get(`/api/v1/orders/` + id)
      .then((res) => {
        setOrderData(res.data);
        setSelectedValue(res.data.status);
      })
      .catch((err) => console.log(err));
  };

  const getDetailData = (id) => {
    axios
      .get(`/api/v1/order-details/get-by-order-id/` + id)
      .then(async (res) => {
        const fetchedData = res.data;

        const updatedData = await Promise.all(
          fetchedData.map(async (item) => {
            try {
              const response = await axios.get(
                `/api/v1/products/${item.productId}`
              );
              return {
                ...item,
                product: response.data,
              };
            } catch (error) {
              console.error(
                `Lỗi khi lấy thông tin sản phẩm ${item.productId}`,
                error
              );
              return { ...item, product: null };
            }
          })
        );
        setOrderDetail(updatedData);
      })
      .catch((err) => console.log(err));
  };

  const handleUpdate = () => {
    axios
      .put(`/api/v1/orders/` + orderData.id, {
        status: selectedValue,
      })
      .then((res) => {
        toast("Cập nhật trạng thái thành công", {
          type: "success",
          autoClose: 1000,
        });
        handleClose(true);
      })
      .catch((err) => console.log(err));
  };

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Quản lý đơn hàng
      </Typography>
      <Box
        sx={{ marginBottom: 2, display: "flex", justifyContent: "end" }}
      ></Box>
      <Paper sx={{ height: 730, width: "100%" }}>
        <DataGrid
          rows={rowsWithIndex}
          columns={columns}
          rowHeight={150}
          rowCount={totalItems}
          pagination
          paginationMode="server"
          onPaginationModelChange={(newPaginationModel) =>
            setPaginationModel(newPaginationModel)
          }
          initialState={{
            pagination: {
              paginationModel: paginationModel,
            },
          }}
          pageSizeOptions={[5, 10]}
          // checkboxSelection
          disableRowSelectionOnClick
          localeText={localeTextVietnamese}
          sx={{
            "& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within": {
              outline: "none",
            },
            "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows":
              {
                marginBottom: 0,
              },
          }}
        />
      </Paper>
      {/* Modal */}
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            width: "100vw",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Paper
            sx={{
              width: 1000,
              height: "95vh",
              p: 5,
              overflowY: "auto",
              overflowX: "hidden",
            }}
          >
            <Typography sx={{ pb: 5 }} variant="h4" component="h2">
              Xem chi tiết đơn hàng
            </Typography>
            <Box
              sx={{
                borderTop: "1px solid #ccc",
                borderBottom: "1px solid #ccc",
                p: "10px 15px",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  borderBottom: "1px solid #ccc",
                  marginBottom: 2,
                }}
              >
                <b>SẢN PHẨM</b>
                <b>GIÁ TIỀN</b>
              </Box>
              {orderDetail.map((item, idx) => (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    pb: 2,
                  }}
                  key={idx}
                >
                  <Box>
                    <Box
                      component="img"
                      sx={{
                        width: "5vw",
                        height: "15vh",
                        objectFit: "cover",
                        borderRadius: "8px",
                      }}
                      alt=""
                      src={item.product.image ?? ""}
                    />
                    <b className="ms-2">
                      {item.product.name}{" "}
                      <span className="ms-5">x {item.quantity}</span>
                    </b>
                  </Box>
                  <b>{formatCurrencyVND(item.product.price * item.quantity)}</b>
                </Box>
              ))}
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                p: "10px 15px",
                alignItems: "center",
              }}
            >
              <b>Trạng thái</b>
              <Select
                value={selectedValue}
                onChange={handleChange}
                sx={{ width: "20%" }}
              >
                {status.map((item, idx) => (
                  <MenuItem key={idx} value={item.value}>
                    {item.name}
                  </MenuItem>
                ))}
              </Select>
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                p: "10px 15px",
              }}
            >
              <b>VAT(10%)</b>
              <b>{formatCurrencyVND(orderData.vatPrice)}</b>
            </Box>
            {orderData.vatPrice > 0 && (
              <>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    p: "10px 15px",
                  }}
                >
                  <b>Tên công ty: </b>
                  <p style={{ margin: 0 }}>{orderData.companyName}</p>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    p: "10px 15px",
                  }}
                >
                  <b>Mã số thuế: </b>
                  <p style={{ margin: 0 }}>{orderData.companyTax}</p>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    p: "10px 15px",
                  }}
                >
                  <b>Email công ty: </b>
                  <p style={{ margin: 0 }}>{orderData.companyEmail}</p>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    p: "10px 15px",
                  }}
                >
                  <b>Địa chỉ công ty: </b>
                  <p style={{ margin: 0 }}>{orderData.companyAddress}</p>
                </Box>
                <hr />
              </>
            )}
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                p: "10px 15px",
              }}
            >
              <b>Tổng tiền</b>
              <b>{formatCurrencyVND(orderData.totalPrice)}</b>
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                p: "10px 15px",
              }}
            >
              <b>Hình thức thanh toán: </b>
              <b>{getPaymentMethod(orderData.payment)}</b>
            </Box>
            <Box sx={{ p: "10px 15px" }}>
              <b>Địa chỉ giao hàng: </b>
              {orderData.address}
            </Box>
            <Box sx={{ display: "flex", justifyContent: "end", gap: 3, pt: 3 }}>
              <Button
                variant="contained"
                color="secondary"
                onClick={handleClose}
              >
                Trở về
              </Button>
              <Button variant="contained" color="info" onClick={handleUpdate}>
                Lưu thay đổi
              </Button>
            </Box>
          </Paper>
        </Box>
      </Modal>
    </Box>
  );
}
